/** @format */

import template from './gb-widget-edit-tools.html';
import './gb-widget-edit-tools.scss';

export const GbWidgetEditToolsComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
        rowLayout: '<',
    },
    controller: class GbWidgetEditToolsComponent {
        constructor($scope, $log, $ccToast) {
            'ngInject';

            this.$scope = $scope;
            this.$log = $log;
            this.$ccToast = $ccToast;

            this.tooltipDirection = 'right';
            this.splitNumbersAndLettersRegex = /[0-9]+|[a-zA-Z]+/g;
            this.defaultSizeUnit = 'px';
        }

        getSelectedWidget() {
            return this.widget;
        }

        noSelectedWidget() {
            return !this.getSelectedWidget();
        }

        sendBelow() {
            if (this.getSelectedWidget().z > 1) {
                // Is not already bottom element
                let widgets = this.gbPresenter.getLayerOrderedWidgets();
                let i = widgets.indexOf(this.getSelectedWidget());

                this.getSelectedWidget().z--;
                widgets[i - 1].z++;

                this.gbPresenter.saveAllWidgets();
            }
        }

        sendToBottom() {
            this.getSelectedWidget().z = 0;
            this.gbPresenter.setWidgetLayers();
            this.gbPresenter.saveAllWidgets();
        }

        bringAbove() {
            let widgets = this.gbPresenter.getLayerOrderedWidgets();
            let i = widgets.indexOf(this.getSelectedWidget());

            if (i < widgets.length - 1) {
                // Is not already top element
                this.getSelectedWidget().z++;
                widgets[i + 1].z--;
                this.gbPresenter.saveAllWidgets();
            }
        }

        bringToTop() {
            let widgets = this.gbPresenter.getLayerOrderedWidgets();
            this.getSelectedWidget().z = widgets.length + 1;
            this.gbPresenter.setWidgetLayers();
            this.gbPresenter.saveAllWidgets();
        }

        rotateLeft() {
            let val = this.getSelectedWidget().rotate_z - 90;

            if (val <= 0) {
                val += 360;
            }

            this.getSelectedWidget().rotate_z = val;
            this.gbEditTools.saveWidget();
        }

        rotateRight() {
            let val = this.getSelectedWidget().rotate_z + 90;

            if (val >= 360) {
                val -= 360;
            }

            this.getSelectedWidget().rotate_z = val;
            this.gbEditTools.saveWidget();
        }

        deleteWidget() {
            this.gbPresenter.removeWidget(this.getSelectedWidget());
            this.deletingWidget = false;

            return this.getSelectedWidget()
                .$delete({
                    auction: this.gbApp.getAuctionUrl(),
                })
                .then((data) => {
                    this.$log.info('Deleted Widget', data);
                })
                .catch((err) => {
                    this.$ccToast.error(err);
                    throw err;
                })
                .finally(() => {
                    this.deletingWidget = false;
                });
        }

        duplicateWidget() {
            let widget = angular.copy(this.widget);

            delete widget.uuid;

            if (widget.x_unit === 'px') {
                widget.x += 10;
            } else {
                widget.x += 1;
            }

            if (widget.y_unit === 'px') {
                widget.y += 10;
            } else {
                widget.y += 1;
            }

            let widgetsArr;

            this.gbPresenter.tempWidgets.push(widget);

            this.widget = widget;
        }
    },
};
